import _ from 'lodash'
import produce from 'immer'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'

import { FeedbotThunk } from '../../store/types'
import { actions as featuresSliceActions, actions } from '../../store/features/featuresSlice'
import { getBooleanFeatureNames } from '../../store/features/utils'
import { devToolsSliceActions } from './devToolsSlice'
import { updateBotProperties } from '../../actions/bot'
import { botFlowSelector } from '../../store/flow/selectors/botFlowSelector'

export const enableAllBooleanFeatures = (): FeedbotThunk => (dispatch, getState) => {
  const booleanFeatureNames = getBooleanFeatureNames()

  const allFeaturesEnabled = _.merge({}, ...booleanFeatureNames.map(name => ({ [name]: true })))

  dispatch(actions.setFeatureValues({ set: 'devForcedFeatures', values: allFeaturesEnabled }))
}

export function forceEnableAllBotFeatures() {
  return devToolsSliceActions.setForcedBotFeatures(
    Object.assign({}, ...Object.values(BotFeatures).map(feature => ({ [feature]: true })))
  ) as any
}

export function forceEnableTelephony(): FeedbotThunk {
  return (dispatch, getState) => {
    dispatch(devToolsSliceActions.modifyForcedBotFeatures({ [BotFeatures.ACTION_STEP_DTMF]: true }))

    dispatch(
      featuresSliceActions.setFeatureValues({
        set: 'devForcedFeatures',
        values: { STEP_NLP_DESIGNER: true }
      })
    )

    const flow = botFlowSelector(getState())

    dispatch(
      updateBotProperties(
        produce(flow!, draft => {
          _.set(draft, 'stepTypeDefaults.question.fuzzyAnswers', true)

          if (!draft.channels) {
            draft.channels = []
          }

          if (!draft.channels.some(channel => channel.type === 'telephony')) {
            draft.channels.push({
              type: 'telephony',
              enabled: true
            })
          }
        })
      )
    )
  }
}
